import { render, staticRenderFns } from "./CreateAccountComplete.vue?vue&type=template&id=4acbe20f"
import script from "./CreateAccountComplete.vue?vue&type=script&lang=js"
export * from "./CreateAccountComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports